<template>
    <TextField
        :id="id"
        ref="field"
        v-model="inputVal"
        v-bind="$attrs"
        inputmode="numeric"
        :mask="zipCodeMask"
        :required="required"
        :disabled="disabled"
    >
        <template #label>
            <slot name="label">{{ $attrs.label }}</slot>
        </template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </TextField>
</template>
<script>
    import masks from "@/util/mask"
    import { validZipCode } from "@/util/validation"
    import FieldProxyMixin from "@/components/form/FieldProxyMixin.vue"

    export default {
        mixins: [FieldProxyMixin],

        inheritAttrs: true,

        props: {
            state: {
                type: String,
                required: false,
            },
        },

        data() {
            return {
                zipCodeMask: masks.zipCode,
            }
        },

        methods: {
            validationSource: function (target, field) {
                field.applyValidator(target, validZipCode.id, validZipCode)

                field.applyValidator(target, "zipCodeState", value => {
                    if (!value) return true
                    if (!this.state) return true
                    if (!this.getRemoteValidator()) return true

                    return this.getRemoteValidator()
                        .validate("zipCodeState", { state: this.state, zipCode: value })
                        .then(({ valid }) => valid)
                })
            },
        },
    }
</script>
